export default "__VITE_ASSET__KN5b2gaQ__"